import { Validator } from 'vee-validate'
import i18n from '@/i18n'

Validator.extend('file_ext', {
  getMessage() {
    return i18n.t('f_v_doc_format')
  },
  validate(value, available_list) {
    return available_list.includes(value.toLowerCase())
  }
})
